// extracted by mini-css-extract-plugin
module.exports = {"innerFormContainer":"styles_innerFormContainer__1bNTO","spacer":"styles_spacer__dcKpP"};